import {MouseEvent, useEffect, useRef, useState} from "react";

interface IToggleStyledProps {
    onClick: Function,
    width?: number,
    height?: number,
    handleColor?: string,
    text?: string,
    textClasses?: string,
    textStyles?: any,
    padding?: number,
    isPositionRight?: boolean,
    isToogle?: boolean,
    adaText?: string,
}

/**
 * Toggle widget.
 */
export const ToggleStyled = (props: IToggleStyledProps) => {
    const padding = props.padding || 2;
    const width = props.width || 70;
    const height = props.height || 26;
    const handleSize = height - padding - padding * 2;
    const handleColor = props.handleColor || '#686868';

    const textRef = useRef<HTMLSpanElement>(null);
    const [btnToogle, setBtnToogle] = useState(props?.isToogle);

    useEffect(() => {
        const $root = document.querySelector(':root') as HTMLElement;
        if(!$root) return;

        const translateXHandle = width - padding * 3 - handleSize;
        $root.style.setProperty('--toggle-switch-translatex-handle', `${ translateXHandle }px`);

        if(!textRef || !textRef.current) return;

        const translateXText = -(width - padding * 3 - textRef.current.offsetWidth);
        $root.style.setProperty('--toggle-switch-translatex-text', `${ translateXText }px`);
    });

    const onClick = (evt: MouseEvent<HTMLButtonElement>) => {
        let _btnToogle = !btnToogle;
        props.onClick(_btnToogle);
        setBtnToogle(_btnToogle);
    };

    // const onKeyUp = (evt: KeyboardEvent<HTMLInputElement>) => {
    //     if(evt.key === 'Enter') {
    //         evt.preventDefault();
    //         props.onClick(!props.isChecked);
    //     }
    // };

    let checkedPositionClass = props.isToogle ? 'toggle-switch__checked' : '';
    if(props.isPositionRight){
        checkedPositionClass = props.isToogle ? '' : 'toggle-switch__checked';
    }

    return (
        <label
            className={`toggle-switch ${ checkedPositionClass } border rounded-3xl bg-white block cursor-pointer flex relative`}
            style={{
                width: `${width}px`,
                height: `${height}px`,
                padding: `${padding}px`,
            }}>

            <button
                className="absolute"
                aria-label={props?.adaText ?? "Toogle"}
                style={{
                    opacity: 0,
                    width: 0,
                    height: 0,
                }}
                onClick={ onClick }
            />

            <span
                className="toggle-switch__handle block"
                style={{
                    width: `${handleSize}px`,
                    height: `${handleSize}px`,
                    borderRadius: '100%',
                    backgroundColor: handleColor,
                }}
            />
            {
                props.text &&
                <span
                    ref={ textRef }
                    className={`toggle-switch__text relative flex items-center flex-1 text-center justify-center text-xs font-normal text-center text-gray-500 ${ props.textClasses }`}
                    style={ props.textStyles }
                >{ props.text }</span>
            }
            <span className="sr-only">Toggle</span>
        </label>
    )
};